import {getAge} from 'utils/date'

export const isUnder18 = (dob: Date) => getAge(dob) < 18
export const isUnder19 = (dob: Date) => getAge(dob) < 19
export const isUnder22 = (dob: Date) => getAge(dob) < 22
export const isPersonUnder19 = ({dob}: {dob: Date | null}) =>
  dob && isUnder19(dob)
